import * as corePixiInit from './core/initializePixi.js'

const loadAndExecuteFunction = (func) => (...args) =>
  corePixiInit.loadGameUIFunctions()
    .then((gameUI) => gameUI[func](...args))
    .catch((error) => {
      console.error(`Error using gameUI.${func}():`, error)
      throw error
    })

const resetPixiGame = loadAndExecuteFunction('resetPixiGame')

export const headShildStrick = loadAndExecuteFunction('headShildStrick')

export const bodyShildStrick = loadAndExecuteFunction('bodyShildStrick')

export const rightHandShildStrick = loadAndExecuteFunction('rightHandShildStrick')

export const leftHandShildStrick = loadAndExecuteFunction('leftHandShildStrick')

export const rightLegShildStrick = loadAndExecuteFunction('rightLegShildStrick')

export const leftLegShildStrick = loadAndExecuteFunction('leftLegShildStrick')

export const heroDeflect = loadAndExecuteFunction('heroDeflect')

export const enableStrike = loadAndExecuteFunction('enableStrike')

export const disableStrike = loadAndExecuteFunction('disableStrike')

export const pixiAppResize = (x, y) => {
  corePixiInit.resizePixiApp(x, y)
  resetPixiGame(x, y)
}

export const magicaSpellApplicationInit = (setIsPixiAssetsLoaded) => corePixiInit.init(setIsPixiAssetsLoaded)

export const magicaSpellAssetsLoad = (setIsPixiAssetsLoaded) => corePixiInit.loadPixiAssets(setIsPixiAssetsLoaded)

export const magicaSpellApplicationDestroy = () => corePixiInit.destroyPixiApp()

export const isSimulate = true
